import { Button, Modal, TextareaControl, TextControl } from '@wordpress/components';
import { addFilter, removeFilter } from '@wordpress/hooks';
import { dispatch, useSelect, withSelect } from '@wordpress/data';
import { Fragment, useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { ReactSortable } from 'react-sortablejs';
import apiFetch from '@wordpress/api-fetch';

// Swap any array or object as per provided index.
const  swapList = (data, old_index, new_index) => {
    if ( 'object' === typeof data ) {
        if (new_index >= Object.keys(data).length) {
            var k = new_index - Object.keys(data).length + 1;
            while (k--) {
                data.push(undefined);
            }
        }
        data.splice(new_index, 0, data.splice(old_index, 1)[0]);
    }
    if ( 'array' === typeof data ) {
        if (new_index >= data.length) {
            var k = new_index - data.length + 1;
            while (k--) {
                data.push(undefined);
            }
        }
        data.splice(new_index, 0, data.splice(old_index, 1)[0]);
    }
    return data;
};
const GalleryItemList = (props) => {
    const { item, onRemove: handleRemove, onChange, thumbnailEditor, thumbnailId, updateThumbnail, updateStoreGalleryData, galleryItems, allData, updateingWPTFeatured } = props
    const icons = {
        image: 'dashicons-format-image',
        audio: 'dashicons-format-audio',
        video: 'dashicons-format-video',
        external: 'dashicons-video-alt3',
        default: 'dashicons-media-default'
    }
    let thumbUrl = item.thumb_url ? item.thumb_url : item.url; // Quick fixes for emty thumbnail issue. 
    const itemType = item.type.match(/(image|audio|video|external)/) || ['default']
    const store = useSelect(select => select('WPTravel/TripEdit'));
    const tripData = store.getAllStore()
    const { updateTripData, updateRequestSending } = dispatch('WPTravel/TripEdit')
    let featuredImageClass = thumbnailId == item.id ? 'featured-image' : ''
    if ( itemType && ( itemType[0].match(/video/) || itemType[0].match(/external/) ) && 'undefined' != typeof item.thumb_id  ) { // Thumbnail for video [ /external/ => External video resource, /video/ => media vedio ]
        featuredImageClass = thumbnailId == item.thumb_id ? 'featured-image' : ''
    }
    let index = parseInt(props.index);
    return <li key={item.id} data-attachmentid={item.id} className={featuredImageClass} data-index={1} id={`wp-travel-gallery-image-list-${item.id}`}>
        <div className={`wptravel-swap-list`}>
            <Button
            disabled={0 == index}
            onClick={(e) => {
                let sorted = swapList( galleryItems, index, index - 1 )
                updateStoreGalleryData(allData, {
                    items: [...sorted]
                })
                updateRequestSending(true); // Temp fixes to reload the content.
                updateRequestSending(false);
            }}><i className="dashicons dashicons-arrow-up"></i></Button>
            <Button 
            // style={{padding:0, display:'block'}}
            disabled={( galleryItems.length - 1 ) === index}
            onClick={(e) => {
                let sorted = swapList( galleryItems, index, index + 1 )
                updateStoreGalleryData(allData, {
                    items: [...sorted]
                })
                updateRequestSending(true);
                updateRequestSending(false);
            }}><i className="dashicons dashicons-arrow-down"></i></Button>
        </div>
        <div className="wptag__dragger"><span className="dashicons dashicons-menu"></span></div>
        <div className="wptag__media-card">
            <div className="wptag__thumbnail">
                {
                    itemType &&
                    <Fragment>
                        {
                           'undefined' !== typeof thumbUrl && thumbUrl.length > 0
                            && <img onClick={() =>{
                                updateThumbnail(item.id, item.source, item.thumb_id )
                            }} disabled={updateingWPTFeatured} src={thumbUrl} width="100%" title={itemType[0].match(/image/) && __('Click to make featured image.', 'wp-travel-pro') || item.title} />
                            || <Fragment>
                                <div className="media-default-thumbnail">
                                    <span className={`dashicons ${icons[itemType[0]]}`}></span>
                                </div>
                                <img src={thumbUrl} width="100%" title={item.title} style={{ display: 'none' }} />
                            </Fragment>
                        }
                        <span className={`dashicons ${icons[itemType[0]]}`}></span>
                        {
                            itemType[0].match(/audio|video|external/) &&
                            <Button className="wptag__edit-thumb" onClick={thumbnailEditor(item.id)}>{__('Change thumbnail', 'wp-travel-pro')}</Button>
                        }
                    </Fragment>
                }
            </div>
            <div className="wptag__media-detail-form">
                <TextControl
                    label={__('Title', 'wp-travel-pro')}
                    value={item.title}
                    placeholder={__('title', 'wp-travel-pro')}
                    onChange={onChange('title', item.id)}
                />
                <TextareaControl
                    label={__('Caption', 'wp-travel-pro')}
                    value={item.caption}
                    placeholder={__('caption', 'wp-travel-pro')}
                    onChange={onChange('caption', item.id)}
                />
                <Button className="wptag__card-remove" onClick={handleRemove(item.id)}>X</Button>
            </div>
        </div>
    </li>
}

const AdvancedGallery = ( props ) => {
    
    const {allData, setFeaturedImage } = props;
    const [{ isOpen, externalLink, iframeLink, title, caption, updateingWPTFeatured }, setState] = useState({
        isOpen: false,
        externalLink: '',
        iframeLink: null,
        title: '',
        caption: '',
        updateingWPTFeatured: false
    });

    const {advanced_gallery:galleryData, _thumbnail_id } = allData;
    
    // const galleryData = allData['advanced_gallery'] || {}
    const galleryItems = 'undefined' != typeof galleryData && galleryData.items ? galleryData.items : [];
    const { updateTripData, updateRequestSending, setTripData, updateStateChange } = dispatch('WPTravel/TripEdit');
    if ( props && props.featuredImageId && props.featuredImageId !== allData._thumbnail_id ) {
        updateTripData({ ...allData, _thumbnail_id: props.featuredImageId  })
    }

    const mediaUploader = wp.media({
        multiple: true
    })
        .on('select', () => {
            const selectedItems = mediaUploader.state().get('selection').toJSON()
            const params = ['index', 'id', 'type', 'source', 'url', 'thumb_url', 'title', 'caption']
            let index = galleryItems.length
            const addedItems = selectedItems.map((item) => {
                return {
                    index,
                    id: item.id,
                    type: item.type,
                    source: '',
                    url: item.url,
                    thumb_url: item.type.match(/image/) && 'undefined' != typeof item.sizes.thumbnail && item.sizes.thumbnail.url || '', //quick fixes for undefined url issue.
                    title: item.name,
                    caption: item.caption
                }
            })

            const updateReadyItems = [
                ...galleryItems,
                ...addedItems
            ]

            updateStoreGalleryData(allData, {
                items: [...updateReadyItems]
            })
        })

    const thumbEditor = id => {
        return e => {
            const mediaInstance = wp.media({
                multiple: false
            })
                .open()
                .on('select', () => {
                    const selectedItems = mediaInstance.state().get('selection').toJSON()
                    const galleryItemsClone = [...galleryItems]
                    let updateReadyItems = []
                    updateReadyItems = galleryItemsClone.map(gi => {
                        if (gi.id == id) {
                            return {
                                ...gi,
                                thumb_url: selectedItems[0].type.match(/image/) && selectedItems[0].sizes.thumbnail.url,
                                thumb_id: selectedItems[0].type.match(/image/) && selectedItems[0].id
                            }
                        }
                        return gi
                    })

                    updateStoreGalleryData(allData, {
                        items: [...updateReadyItems]
                    })
                })
        }
    }
    const setThumbnail = (id, source, thumb_id) => {
        if ( source ) { // external source like youtube, vimeo
            updateTripData({ ...allData, _thumbnail_id: thumb_id  })
        } else {
            id && apiFetch({ path: `/wp/v2/media/${id}` })
            .then((res) => {
                if ( 'image' == res.media_type ) {
                    updateTripData({ ...allData, _thumbnail_id: id })

                    setState(state => ({ ...state, updateingWPTFeatured: true }))
                    // const newMedia = getMedia( id ); // issue due to newMedia is undefined.
                    // saveMedia(newMedia);
                    setFeaturedImage( id );
                    setState(state => ({ ...state, updateingWPTFeatured: false }))

                } else {
                    // Thumbnail set for video.
                    let item
                    for (item of galleryItems) {
                        if ( item.id == id && 'undefined' != typeof item.thumb_id ) {
                            updateTripData({ ...allData, _thumbnail_id: item.thumb_id  })
                            
                        }
                    }
                }
            })
        }
    }

    // Removes items from list when remove button clicked.
    const handleRemove = (id) => (
        e => {
            if (!confirm(__( 'Are you sure to delete this image?', 'wp-travel-pro' ) )) {
                return false;
            }
            // e.preventDefault()
            const filtereditems = galleryItems.filter(item => item.id !== id)

            updateStoreGalleryData(allData, {
                items: [...filtereditems]
            })
        }
    )

    const renderExternalLink = link => {
        var url = link;
        var parts = url.match(/(?:(?:https?:)?\/\/)?(?:www\.)?youtu(?:be\.com\/(?:watch\?(?:.*?&(?:amp;)?)*v=|v\/|embed\/)|\.be\/)([\w‌​\-]+)(?:(?:&(?:amp;)?|\?)[\w\?=]*)*/)
        let iframeLink;
        if (parts) {
            iframeLink = `https://www.youtube.com/embed/${parts[1]}`
        }
        parts = url.match(/(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/)
        if (parts) {
            iframeLink = `https://player.vimeo.com/video/${parts[4]}?portrait=0`
        }

        setState(state => ({ ...state, iframeLink, externalLink: link }))
    }

    // Final Store Dispatcher.
    const updateStoreGalleryData = (state, galleryData) => {
        updateTripData({
            ...state, // allData
            'advanced_gallery': {
                ...galleryData
            }
        })
    }

    /**
     * Handles and update changes in each item.
     *
     * @param {string} name Item data key.
     * @param {int} id Media id
     */
    const handleChange = (name, id) => {
        return value => {
            // const galleryItemsArr = Object.values(galleryItems)
            const itemIndex = galleryItems.findIndex(item => item.id == id)
            const updatedGalleryItems = [...galleryItems]
            if (itemIndex > -1) {
                updatedGalleryItems[itemIndex] = {
                    ...galleryItems[itemIndex],
                    [name]: value
                }
            }

            updateStoreGalleryData(allData, {
                items: [...updatedGalleryItems]
            })
        }
    }

    const parseUrl = function (url) {
        var group = url && url.match(/youtube|youtu.be/) && url.match(/(?:(?:https?:)?\/\/)?(?:www\.)?youtu(?:be\.com\/(?:watch\?(?:.*?&(?:amp;)?)*v=|v\/|embed\/)|\.be\/)([\w‌​\-]+)(?:(?:&(?:amp;)?|\?)[\w\?=]*)*/) || url.match(/vimeo/) && url.match(/(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/)
        return group
    }

    const addToGallery = () => {
        const index = galleryItems.length
        const group = parseUrl(externalLink)
        let data = {}
        if (group && group[0].match(/youtube|youtu.be/)) {
            data['source'] = 'youtube',
                data['url'] = 'https://www.youtube.com/embed/' + group[1]
            data['id'] = group[1]
            data['type'] = 'external'
            data['thumb_url'] = 'https://i.ytimg.com/vi_webp/' + group[1] + '/hqdefault.webp'
        } else if (group && group[0].match(/vimeo/)) {
            data['source'] = 'vimeo',
                data['url'] = 'https://player.vimeo.com/video/' + group[4]
            data['id'] = group[4]
            data['type'] = 'external'
            data['thumb_url'] = ''
        }
        data['index'] = index
        data['title'] = title
        data['caption'] = caption

        const updatedGalleryItems = [...galleryItems, { ...data }]

        updateStoreGalleryData(allData, {
            items: [...updatedGalleryItems]
        })
        setState(state => {
            return {
                ...state,
                isOpen: false,
                externalLink: '',
                iframeLink: '',
                title: '',
                caption: ''
            }
        })
    }

    return <div className="wp-travel-ui wp-travel-ui-card wp-travel-ui-card-no-border">
        <div className="wptag-tab-content">
            <div className="wp-travel-advanced-gallery-title-wrap">
                <h3>{__('Gallery', 'wp-travel-pro')}</h3>
                <div className="wp-travel-advance-gallery-buttons">
                    <Button className="wptag__uploader-btn button" onClick={(e) => {
                        mediaUploader.open()
                    }}>Add media</Button>
                    <Button
                        className="wptag__add-external-link-btn button"
                        onClick={e => {
                            setState(state => ({ ...state, isOpen: true }))
                        }}>{__('Insert From URL', 'wp-travel-pro')}</Button>
                </div>
            </div>
            <div className="wptag__items-list wp-travel-advanced-gallery">
                {
                    <ReactSortable
                        handle=".wp-travel-advanced-gallery .wptag__dragger .dashicons"
                        list={galleryItems}
                        setList={newList => updateStoreGalleryData(allData, {
                            items: [...newList]
                        })}
                    >
                        {galleryItems && galleryItems.map((item, i) => {
                            return <GalleryItemList
                                item={item}
                                key={i} // For Block
                                index={i} // to sort list.
                                onRemove={handleRemove}
                                onChange={handleChange}
                                thumbnailId={_thumbnail_id}
                                thumbnailEditor={thumbEditor}
                                updateThumbnail={setThumbnail}
                                updateStoreGalleryData={updateStoreGalleryData}
                                galleryItems={galleryItems}
                                allData={allData}
                                updateingWPTFeatured={updateingWPTFeatured}
                                />
                        })}
                    </ReactSortable>
                }
            </div>
            {isOpen && <Modal
                onRequestClose={() => setState(state => ({ ...state, isOpen: false }))}>
                <div className="wptag__external-link-form" data-id="">
                    <div className="wp-travel-advance-gallery-popup-form">
                        <TextControl
                            label={__('Youtube/Vimeo Link', 'wp-travel-pro')}
                            value={externalLink}
                            onChange={externalLink => renderExternalLink(externalLink)}
                            placeholder={__('Youtube/Vimeo Video Link', 'wp-travel-pro')}
                        />
                        <TextControl
                            label={__('Title', 'wp-travel-pro')}
                            value={title}
                            onChange={title => setState(state => ({ ...state, title }))}
                            placeholder={__('Title', 'wp-travel-pro')}
                        />
                        <TextareaControl
                            label={__('Caption', 'wp-travel-pro')}
                            value={caption}
                            onChange={caption => setState(state => ({ ...state, caption }))}
                            placeholder={__('Caption', 'wp-travel-pro')}
                        />
                        <Button
                            className="button button-primary button-large wptag__add-external-media"
                            onClick={() => addToGallery()}>Add</Button>
                        <Button className="button wptag__cancel-external-media" onClick={() => setState(state => ({ ...state, isOpen: false }))}>Cancel</Button>
                    </div>
                    <div className="wptag__embed-preview">
                        {
                            iframeLink && <iframe width="300" height="200" src={iframeLink}></iframe> ||
                            <span className="preview-empty-message">{__('Please add URL to view video.', 'wp-travel-pro')}</span>
                        }
                    </div>
                </div>
            </Modal>}
        </div>
    </div>
}


export default withSelect( (select ) => {
    // const { getMedia } = typeof select( 'core' ) != 'undefined' && select( 'core' ) != null ? select( 'core' ) : null;
    // const { saveMedia } = dispatch( 'core' );
    // const { getEditedPostAttribute } = select( 'core/editor' );
    // const featuredImageId = getEditedPostAttribute( 'featured_media' );
    // return {
    //     media: featuredImageId && typeof getMedia != 'undefined' && getMedia != null ? getMedia( featuredImageId ) : null,
    //     featuredImageId,
    //     // getMedia,
    //     // saveMedia,
    //     setFeaturedImage: function(attachmentId) {
	// 		dispatch('core/editor').editPost({ featured_media: attachmentId });
	// 	}
    // };
  })( AdvancedGallery )